import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import * as React from "react";
import NavigationBuilderContext from "./NavigationBuilderContext";
import NavigationRouteContext from "./NavigationRouteContext";
var VISITED_ROUTE_KEYS = Symbol("VISITED_ROUTE_KEYS");
export var shouldPreventRemove = function(emitter, beforeRemoveListeners, currentRoutes, nextRoutes, action) {
    var nextRouteKeys = nextRoutes.map(function(route) {
        return route.key;
    });
    // Call these in reverse order so last screens handle the event first
    var removedRoutes = currentRoutes.filter(function(route) {
        return !nextRouteKeys.includes(route.key);
    }).reverse();
    var // @ts-expect-error: add this property to mark that we've already emitted this action
    _action_VISITED_ROUTE_KEYS;
    var visitedRouteKeys = (_action_VISITED_ROUTE_KEYS = action[VISITED_ROUTE_KEYS]) !== null && _action_VISITED_ROUTE_KEYS !== void 0 ? _action_VISITED_ROUTE_KEYS : new Set();
    var beforeRemoveAction = _object_spread_props(_object_spread({}, action), _define_property({}, VISITED_ROUTE_KEYS, visitedRouteKeys));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = removedRoutes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var route = _step.value;
            var _beforeRemoveListeners_route_key;
            if (visitedRouteKeys.has(route.key)) {
                continue;
            }
            // First, we need to check if any child screens want to prevent it
            var isPrevented = (_beforeRemoveListeners_route_key = beforeRemoveListeners[route.key]) === null || _beforeRemoveListeners_route_key === void 0 ? void 0 : _beforeRemoveListeners_route_key.call(beforeRemoveListeners, beforeRemoveAction);
            if (isPrevented) {
                return true;
            }
            visitedRouteKeys.add(route.key);
            var event = emitter.emit({
                type: "beforeRemove",
                target: route.key,
                data: {
                    action: beforeRemoveAction
                },
                canPreventDefault: true
            });
            if (event.defaultPrevented) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
export default function useOnPreventRemove(param) {
    var getState = param.getState, emitter = param.emitter, beforeRemoveListeners = param.beforeRemoveListeners;
    var addKeyedListener = React.useContext(NavigationBuilderContext).addKeyedListener;
    var route = React.useContext(NavigationRouteContext);
    var routeKey = route === null || route === void 0 ? void 0 : route.key;
    React.useEffect(function() {
        if (routeKey) {
            return addKeyedListener === null || addKeyedListener === void 0 ? void 0 : addKeyedListener("beforeRemove", routeKey, function(action) {
                var state = getState();
                return shouldPreventRemove(emitter, beforeRemoveListeners, state.routes, [], action);
            });
        }
    }, [
        addKeyedListener,
        beforeRemoveListeners,
        emitter,
        getState,
        routeKey
    ]);
}
